// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input, TextField
} from "@mui/material";

// App Imports


import {changeInterest} from "./interestSlice";
import {addInterest, editInterest} from "./InterestClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import Stack from "@mui/material/Stack";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import dayjs from "dayjs";


// Main Function
export default function InterestDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorInterestId = useSelector((state) => state.interestSlc.value.id);
    const selectorInterestDrawerState = useSelector((state) => state.interestSlc.value.interestDrawerState);
    const selectorInterestDrawerMode = useSelector((state) => state.interestSlc.value.interestDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register,reset, control, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Interest data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorInterestDrawerMode==="Add"){
            addInterest(data)
                .then(() => {
                    console.log("Interest added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeInterest({
                    id: null, externalId: null, rateDate: null,
                    rate: null,
                    source: null,
                    effectiveDate: null, expiredOn: null,
                    subCount: null, countDate: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    interestGridRefresh: true, interestDrawerState: false, interestDrawerMode: null}))
            })}
        if(selectorInterestDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addInterest(data)
                .then(() => {
                    console.log("Interest cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeInterest({
                    id: null, externalId: null, rateDate: null,
                    rate: null,
                    source: null,
                    effectiveDate: null, expiredOn: null,
                  status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    interestGridRefresh: true, interestDrawerState: false, interestDrawerMode: null}))


            })}
        if(selectorInterestDrawerMode==="Edit"){
            console.log("This is the Interest Id I am going to edit")
            console.log(selectorInterestId)
            editInterest(selectorInterestId, data)
                .then(() => {
                    console.log("Interest edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeInterest({
                    interestGridRefresh: true, interestDrawerState: false, interestDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeInterestDrawer() {
        dispatchData(changeInterest({interestDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************

    const interest = useSelector((state) => state.interestSlc.value);

    useEffect(() => {

        reset({
            ...interest,
            rateDate: interest.rateDate
                ? dayjs(interest.rateDate)
                : null,

            effectiveDate: interest.effectiveDate
                ? dayjs(interest.effectiveDate)
                : null,

            expiredOn: interest.expiredOn
                ? dayjs(interest.expiredOn)
                : null,
        });


    }, [interest, reset]);
    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    // ****************** BEGIN FORM ****************************

    function interestForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeInterestDrawer()}>Interest Form</h2>
                    <h4>{selectorInterestDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('id', { required: true })}
                        id="id" name="id"  label="id" aria-describedby="id_entry"
                        defaultValue=        {Number(useSelector((state) => state.interestSlc.value.id))}
                    />
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('externalId', { required: true })}
                            id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                            defaultValue=        {useSelector((state) => state.interestSlc.value.externalId)}
                            sx={{ width: 200 }} />
                        {/*<TextField*/}
                        {/*    {...register('rateDate', { required: true })}*/}
                        {/*    id="rateDate"   name="rateDate"  label="Rate Date" aria-describedby="rateDate_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.interestSlc.value.rateDate)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        <FormDatePicker
                            name="rateDate"
                            label="Rate Date"
                            control={control}
                            width={230}
                            variant = "outlined"
                            />
                        {/*<TextField*/}
                        {/*    {...register('service', { required: true })}*/}
                        {/*    id="service"   name="service"  label="Service" aria-describedby="service_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.interestSlc.value.service)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        {/*<TextField*/}
                        {/*    {...register('source', { required: true })}*/}
                        {/*    id="source"   name="source"  label="Source" aria-describedby="source_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.interestSlc.value.source)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('rate', { required: true })}
                            id="rate"   name="rate"  label="Rate" aria-describedby="rate_entry"
                            defaultValue=        {useSelector((state) => state.interestSlc.value.rate)}
                            sx={{ width: 200 }} />
                        <TextField
                            {...register('source', { required: true })}
                            id="source"   name="source"  label="Source" aria-describedby="source_entry"
                            defaultValue=        {useSelector((state) => state.interestSlc.value.source)}
                            sx={{ width: 200 }} />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('effectiveDate', { required: true })}*/}
                        {/*    id="effectiveDate"   name="effectiveDate"  label="Effective Date" aria-describedby="effectiveDate_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.interestSlc.value.effectiveDate)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        {/*<TextField*/}
                        {/*    {...register('expiredOn', { required: false })}*/}
                        {/*    id="expiredOn"   name="expiredOn"  label="Expired On" aria-describedby="expiredOn_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.interestSlc.value.expiredOn)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        <FormDatePicker
                            name="effectiveDate"
                            label="Effective Date"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <FormDatePicker
                            name="expiredOn"
                            label="Expired On"
                            control={control}
                            width={230}
                            variant = "outlined"
                        />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.interestSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.interestSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.interestSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.interestSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeInterestDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorInterestDrawerState}
                onClose={closeInterestDrawer}
            >
                {interestForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
